import { useAuth } from '@/modules/auth/AuthContext'

export function usePermission(permission: string): boolean {
  const { state } = useAuth()

  if (state.status !== 'authenticated') return false
  if (!state.user.permissions) return false

  // Admin bypass
  if (state.user.roles.includes('admin')) return true

  return state.user.permissions.includes(permission)
}
